import { Component, OnInit } from '@angular/core';
import { StepperServiceBase } from './stepper.service';

@Component({
  selector: 'wz-stepper2',
  templateUrl: './stepper2.component.html',
  styleUrls: ['./stepper2.component.scss'],
  standalone: false,
})
export class Stepper2Component implements OnInit {
  constructor(private stepperService: StepperServiceBase) {}
  ngOnInit() {}

  onStepClick(i: number) {
    if (i > this.maxStep || this.isStepperDisabled) {
      return;
    }

    this.stepperService.goToStep(i);
  }

  public get isStepperDisabled() {
    return this.stepperService.isStepperDisabled;
  }

  public get currentStep() {
    return this.stepperService.currentStep;
  }

  public get maxStep() {
    return this.stepperService.maxStep;
  }

  public get steps() {
    return this.stepperService.steps.map((s) => s.label);
  }
}
